import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["disabled"],
  _excluded2 = ["disabled"];
var _templateObject, _templateObject2, _templateObject3;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { Checkbox as MuiCheckbox } from '@material-ui/core';
import { COLORS } from "../../constants/colors";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _Checkbox = styled(function (props) {
  return /*#__PURE__*/React.createElement(MuiCheckbox, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    padding: 0px;\n    height: 40px;\n    width: 40px;\n    box-sizing: border-box;\n    &&:hover {\n      background-color: ", ";\n    }\n\n    .MuiIconButton-label {\n      height: 24px;\n      width: 24px;\n    }\n\n    &.Mui-focusVisible {\n      border: 2px solid ", ";\n      border-radius: 7px;\n      width: 30px;\n      height: 30px;\n      margin: 5px;\n    }\n  }\n"])), COLORS.checkbox.unchecked.hover.background, COLORS.checkbox.checked.main.color);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _IconNotChecked = styled(function (_ref) {
  var disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", rest);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 4px;\n  background-color: ", ";\n  border: solid ", " 2px;\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n"])), COLORS.checkbox.unchecked.main.background, getBorderColorForUncheckedBox);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _IconChecked = styled(function (_ref2) {
  var disabled = _ref2.disabled,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  background-color: ", ";\n  box-sizing: border-box;\n  height: 100%;\n  width: 100%;\n\n  svg {\n    * {\n      fill: white;\n    }\n  }\n"])), function (props) {
  return props.disabled ? COLORS.checkbox.checked.disabled.color : COLORS.checkbox.checked.main.color;
});
function getBorderColorForUncheckedBox(props) {
  if (props.disabled) {
    return COLORS.checkbox.unchecked.disabled.color;
  }
  if (props.error) {
    return COLORS.negative.active;
  }
  return COLORS.checkbox.unchecked.main.color;
}